import React, { createContext, useCallback, useState } from "react";
import { getBillingBalance } from "../api/context/billing";

export const SelectionContext = createContext();

const HAS_ATTEMPTED_AI_KEY = "hasAttemptedAi";

const readHasAttempted = () => {
    try {
        return localStorage.getItem(HAS_ATTEMPTED_AI_KEY) === "true";
    } catch (e) {
        return false;
    }
};

const StoreContext = ({ children }) => {

    const [updateCount, setUpdateCount] = useState(0);
    const [notifications, setNotifications] = useState([]);
    const [messages, setMessages] = useState([]);
    const [messageUpdate, setMessageUpdate] = useState(false);
    const [notificationsAll, setNotificationsAll] = useState([]);
    const [ordersTrigger, setOrdersTrigger] = useState(false);

    const [billingBalance, setBillingBalance] = useState(null);
    const [billingLoading, setBillingLoading] = useState(false);
    const [hasAttemptedAi, setHasAttemptedAiState] = useState(readHasAttempted());

    const markAttemptedAi = useCallback(() => {
        try {
            localStorage.setItem(HAS_ATTEMPTED_AI_KEY, "true");
        } catch (e) { }
        setHasAttemptedAiState(true);
    }, []);

    const refreshBillingBalance = useCallback(async () => {
        setBillingLoading(true);
        try {
            const res = await getBillingBalance();
            if (res?.data?.success) {
                setBillingBalance(res.data.data);
                return res.data.data;
            }
        } catch (e) {
        } finally {
            setBillingLoading(false);
        }
        return null;
    }, []);

    return (
        <SelectionContext.Provider value={{
            updateCount, setUpdateCount,
            notifications, setNotifications,
            notificationsAll, setNotificationsAll,
            messages, setMessages,
            messageUpdate, setMessageUpdate,
            ordersTrigger, setOrdersTrigger,
            billingBalance, setBillingBalance,
            billingLoading,
            refreshBillingBalance,
            hasAttemptedAi, markAttemptedAi,
        }}>
            {children}
        </SelectionContext.Provider>
    )

}
export default StoreContext